import { Loader2, Play, Pause } from "lucide-react";

/**
 * En-tête d'une carte Artwork : bouton play radio + métadonnées + badge validé.
 */
function PlayButtonIcon({ isPlaying, isLoading }) {
  if (isLoading) return <Loader2 size={16} className="mw-spin" />;
  if (isPlaying) return <Pause size={16} />;
  return <Play size={16} />;
}

function TrackMeta({ name, artist, title, hasTrack }) {
  return (
    <div className="art-card-meta">
      <div className="art-radio-name">{name}</div>
      {hasTrack ? (
        <>
          <div className="art-track-title">{title}</div>
          <div className="art-track-artist">{artist}</div>
        </>
      ) : (
        <div className="art-track-empty">Aucune métadonnée live</div>
      )}
    </div>
  );
}

function ValidatedBadge({ validated }) {
  if (!validated) return null;
  const isPerma = validated.status === "permanent";
  return (
    <div className={`art-badge ${isPerma ? "art-badge-perma" : ""}`}>
      {isPerma ? "⭐ Permanent" : "✓ Validé"}
    </div>
  );
}

export function ArtworkHeader({ radio, artist, title, hasTrack, validated, audio }) {
  const isPlaying = audio.playingId === radio.id;
  const isLoading = audio.isLoading && isPlaying;
  return (
    <div className="art-card-top">
      <button
        type="button"
        className={`art-play ${isPlaying ? "art-play-on" : ""}`}
        onClick={() => audio.toggle(radio.id, radio.stream_url)}
        data-testid={`art-play-${radio.id}`}
        title={isPlaying ? "Couper l'écoute" : "Écouter cette radio"}
      >
        <PlayButtonIcon isPlaying={isPlaying} isLoading={isLoading} />
      </button>
      <TrackMeta name={radio.name} artist={artist} title={title} hasTrack={hasTrack} />
      <ValidatedBadge validated={validated} />
    </div>
  );
}
